// extracted by css-extract-rspack-plugin
export default {"textBanner":"header-fragment__Banner_textBanner__VWEOy"};